export const RIDER_LOCATION_FRESHNESS_MS = 3 * 60 * 1000;

export const normalizeRiderLocation = (location) => {
  if (!location || typeof location !== "object") return null;

  const coordinates = Array.isArray(location.coordinates)
    ? location.coordinates
    : null;
  const lat = Number(coordinates ? coordinates[1] : location.lat ?? location.latitude);
  const lng = Number(
    coordinates ? coordinates[0] : location.lng ?? location.lon ?? location.longitude,
  );

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  if (lat === 0 && lng === 0) return null;

  const lastUpdated = location.lastUpdated || location.timestamp || null;
  return {
    lat,
    lng,
    heading: Number.isFinite(Number(location.heading)) ? Number(location.heading) : null,
    speed: Number.isFinite(Number(location.speed)) ? Math.max(0, Number(location.speed)) : null,
    lastUpdated,
  };
};

export const isFreshRiderLocation = (
  location,
  now = Date.now(),
  maxAgeMs = RIDER_LOCATION_FRESHNESS_MS,
) => {
  const normalized = normalizeRiderLocation(location);
  if (!normalized?.lastUpdated) return false;
  const timestamp = new Date(normalized.lastUpdated).getTime();
  if (!Number.isFinite(timestamp)) return false;
  return now - timestamp <= maxAgeMs;
};

export const riderLocationAgeLabel = (location, now = Date.now()) => {
  const normalized = normalizeRiderLocation(location);
  if (!normalized?.lastUpdated) return "No GPS timestamp";
  const timestamp = new Date(normalized.lastUpdated).getTime();
  if (!Number.isFinite(timestamp)) return "No GPS timestamp";
  const seconds = Math.max(0, Math.floor((now - timestamp) / 1000));
  if (seconds < 15) return "GPS just now";
  if (seconds < 60) return `GPS ${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `GPS ${minutes}m ago`;
  return `GPS ${Math.floor(minutes / 60)}h ago`;
};
